@if (isLoaded) {
<div class="listing-filter ion-hide-sm-down">
  <ion-row class="ion-justify-content-between align-items-center">
    <ion-col size="auto">
      <ion-select slot="end" placeholder="Search by..." interface="popover" aria-label="Search by">
        <ion-select-option>Unit Name</ion-select-option>
        <ion-select-option>Code</ion-select-option>
        <ion-select-option>District</ion-select-option>
      </ion-select>
    </ion-col>
    <ion-col size="auto">
      <ion-input placeholder="Search by unit name, code..."
                 style="--border-radius: 8px; min-height: 42px"
                 mode="md"
                 fill="outline"
                 [clearInput]="true"
                 [formControl]="searchQuery">
      </ion-input>
    </ion-col>
    <ion-col class="ion-text-right flex align-items-center ion-justify-content-end">
      @if (propertyService.isSearching) {
        <ion-spinner name="circular"></ion-spinner>
      }
      <ion-button fill="outline" color="dark" (click)="showFilterPopover('price', $event)">{{ (priceRange.value?.lower ?? 0)/1000 | number: '1.0-0'  }}k - {{(priceRange.value?.upper ?? 0)*currencyConvertService.exchangeRates[currencyConvertService.localCurrency()]/1000 | number: '1.0-0' }}k {{currencyConvertService.localCurrency()}}</ion-button>
      <ion-button fill="outline" color="dark" (click)="showFilterPopover('beds', $event)">{{ bedrooms.value ? bedrooms.value : '' }} Beds</ion-button>
<!--      <ion-button (click)="showFilterPopover('furniture', $event)" fill="outline" color="dark">With appliances</ion-button>-->
      <ion-select interface="popover"
                  mode="md"
                  fill="outline"
                  [(ngModel)]="furnishingType"
                  (ionDismiss)="dropDownClosed($event)"
                  [multiple]="true"
                  [placeholder]="'With appliances'"
                  aria-label="Select furnishing type">
        @for (f of content?.furnishingType; track f.id) {
          <ion-select-option [value]="f.value">{{ f.label }}</ion-select-option>
        }
      </ion-select>
      <ion-button (click)="showFilterPopover('floor', $event)" fill="outline" color="dark">{{floorRange.value?.lower}} - {{floorRange.value?.upper}} Sq.M Area</ion-button>
      <ion-button fill="outline" (click)="showFilterPopover('age', $event)" color="dark">{{ ageRange.value?.lower }} - {{ ageRange.value?.upper }} Age</ion-button>
<!--      <ion-button (click)="searchData(filterService.filterData())">Filter</ion-button>-->
      @if (propertyService.filterValues()) {
        <ion-button fill="outline" (click)="resetFilter()" color="dark">Reset</ion-button>
      }
    </ion-col>
  </ion-row>
</div>

<!--@defer (hydrate on timer(1000)) {-->
<ion-toolbar class="ion-hide-sm-up mobile-filter">
  <ion-select fill="outline" mode="md" placeholder="Search by..." interface="popover" aria-label="Search by">
    <ion-select-option>Unit Name</ion-select-option>
    <ion-select-option>Code</ion-select-option>
    <ion-select-option>District</ion-select-option>
  </ion-select>
  <ion-searchbar placeholder="Search..."
                 [formControl]="searchQuery"></ion-searchbar>
</ion-toolbar>
<!--}-->
<ion-toolbar class="ion-hide-sm-up scrollable">
  <ion-segment [scrollable]="true">
    <ion-segment-button (click)="showFilterPopover('price', $event)">{{ (priceRange.value?.lower ?? 0)/1000 | number: '1.0-0'  }}k - {{(priceRange.value?.upper ?? 0)*currencyConvertService.exchangeRates[currencyConvertService.localCurrency()]/1000 | number: '1.0-0' }}k {{currencyConvertService.localCurrency()}}</ion-segment-button>
    <ion-segment-button (click)="showFilterPopover('beds', $event)">{{ bedrooms.value ? bedrooms.value : '' }} Beds</ion-segment-button>
    <ion-segment-button (click)="showFilterPopover('floor', $event)">{{floorRange.value?.lower}} - {{floorRange.value?.upper}} Sq.ft Area</ion-segment-button>
    <ion-segment-button (click)="showFilterPopover('age', $event)">{{ ageRange.value?.lower }} - {{ ageRange.value?.upper }} Age</ion-segment-button>
  </ion-segment>
</ion-toolbar>
}
